/**
 * Lightweight vibration helpers for supported mobile browsers (mostly Android).
 * iOS Safari does not expose meaningful haptics to typical web pages — visual
 * feedback must carry the UX everywhere.
 */

const LIGHT_MS = 12;
const MEDIUM_MS = 18;

function prefersReducedMotion(): boolean {
  if (typeof window === "undefined" || !window.matchMedia) {
    return false;
  }
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

function canVibrate(): boolean {
  return (
    typeof navigator !== "undefined" && typeof navigator.vibrate === "function"
  );
}

/** Short “tap” pulse. No-ops when unsupported or when reduced-motion is set. */
export function lightTap(): void {
  if (!canVibrate() || prefersReducedMotion()) {
    return;
  }
  try {
    navigator.vibrate(LIGHT_MS);
  } catch {
    // Some browsers throw if vibration is disabled / policy blocks
  }
}

/** Slightly longer pulse for confirmations / stronger affordance. */
export function mediumTap(): void {
  if (!canVibrate() || prefersReducedMotion()) {
    return;
  }
  try {
    navigator.vibrate(MEDIUM_MS);
  } catch {
    // same as lightTap
  }
}
